import { ICommonMobileSetting, ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigDeeplinkSettings } from "./app-settings-config-deeplink";

export interface IConfigDeeplinkInputState {
  showModal: boolean;
  editingDeeplinkId: string;
}

export interface IConfigDeeplinkInputProps {
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigDeeplinkInput extends PureComponent<IConfigDeeplinkInputProps, IConfigDeeplinkInputState> {
  formInputName = ["apiConfig", "commonMobileSettingsId"];

  constructor(props: IConfigDeeplinkInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingDeeplinkId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingDeeplinkId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingDeeplink = (id: string) => {
    this.setState({ editingDeeplinkId: id, showModal: true });
  };

  render() {
    const optionsList = [
      { id: null, name: "Default" } as unknown as ICommonMobileSetting,
      ...(this.props.commonSettings.commonMobileSettings || [])
    ];
    return (
      <>
        <ConfigDeeplinkSettings
          formInputName={this.formInputName}
          showModal={this.state.showModal}
          closeModal={() => {
            this.closeModal();
          }}
          editingDeeplinkId={this.state.editingDeeplinkId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={optionsList}
          tooltipContentKey="appsettings_deeplinksetting_configuration"
          onAddNew={this.openModal}
          onEdit={this.setEditingDeeplink}
          dropdownTestId="appSettingsDeeplinkSettingDropdown"
          addNewTestId="appSettingsDeeplinkSettingAddNewButton"
          editTestId="appSettingsDeeplinkSettingEditButton"
        />
      </>
    );
  }
}
